export interface Payload {
  traceId: string;
  adobeMappedData: {
    channel?: string;
    eVar2?: string;
    prop2?: string;
    products: string;
  };
}

export default function isPayload(payload: any): payload is Payload {
  return payload && 'adobeMappedData' in payload && 'traceId' in payload;
}
